import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface EmojiU1faaa1IconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const EmojiU1faaa1Icon = ({ className, ...props }: EmojiU1faaa1IconProps) => (
  <svg
    className={cn(className)}
    fill="none"
    height="22"
    viewBox="0 0 22 22"
    width="22"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.6875 16.0412V5.95906C0.6875 5.15469 1.34578 4.49812 2.14844 4.49812H19.8516C20.6559 4.49812 21.3125 5.1564 21.3125 5.95906V16.043C21.3125 16.8473 20.6542 17.5039 19.8516 17.5039H2.14844C1.34578 17.5039 0.6875 16.8456 0.6875 16.0412Z"
      fill="#B9E4EA"
    />
    <path
      d="M7.29275 15.3192H2.61088C2.46479 15.3192 2.34619 15.2006 2.34619 15.0545V8.69172C2.34619 8.54563 2.46479 8.42703 2.61088 8.42703H7.29275C7.43885 8.42703 7.55744 8.54563 7.55744 8.69172V15.0563C7.55744 15.2006 7.43885 15.3192 7.29275 15.3192Z"
      fill="white"
    />
    <path
      d="M7.5404 15.1164V15.3192H2.36353V15.1164C2.36353 14.3206 3.37243 13.9356 4.49134 13.8548V13.7998C4.0204 13.6572 3.59931 13.3031 3.39134 12.7205C3.17821 12.6448 3.05618 11.9453 3.1129 11.8542C3.07165 11.5603 2.79321 9.25546 4.95196 9.23999C7.10556 9.2503 6.83056 11.55 6.78587 11.8491C6.84087 11.9401 6.72056 12.6397 6.50743 12.7153C6.30462 13.298 5.88353 13.6572 5.41259 13.7998V13.8497C6.53837 13.9408 7.5404 14.367 7.5404 15.1164Z"
      fill="url(#paint0_linear_262_44914)"
    />
    <path
      d="M19.8516 4.49625H2.14844C1.34406 4.49625 0.6875 5.15453 0.6875 5.95718V6.87328H21.3125V5.95718C21.3125 5.15453 20.6542 4.49625 19.8516 4.49625Z"
      fill="#2F7889"
    />
    <path
      d="M13.5936 9.24H9.33801C9.11285 9.24 8.93066 9.05781 8.93066 8.83265C8.93066 8.6075 9.11285 8.42531 9.33801 8.42531H13.5936C13.8188 8.42531 14.001 8.6075 14.001 8.83265C13.9993 9.05781 13.8171 9.24 13.5936 9.24Z"
      fill="#82AEC0"
    />
    <path
      d="M15.1182 11.2664H9.33801C9.11285 11.2664 8.93066 11.0842 8.93066 10.8591C8.93066 10.6339 9.11285 10.4517 9.33801 10.4517H15.1182C15.3433 10.4517 15.5255 10.6339 15.5255 10.8591C15.5238 11.0842 15.3416 11.2664 15.1182 11.2664Z"
      fill="#82AEC0"
    />
    <path
      d="M12.9371 13.2928H9.33801C9.11285 13.2928 8.93066 13.1106 8.93066 12.8855C8.93066 12.6603 9.11285 12.4781 9.33801 12.4781H12.9371C13.1622 12.4781 13.3444 12.6603 13.3444 12.8855C13.3427 13.1106 13.1605 13.2928 12.9371 13.2928Z"
      fill="#82AEC0"
    />
    <path
      d="M11.9574 15.3192H9.33801C9.11285 15.3192 8.93066 15.137 8.93066 14.9119C8.93066 14.6867 9.11285 14.5045 9.33801 14.5045H11.9574C12.1825 14.5045 12.3647 14.6867 12.3647 14.9119C12.3647 15.137 12.1825 15.3192 11.9574 15.3192Z"
      fill="#82AEC0"
    />
    <path
      d="M21.3125 9.24516C21.2832 9.24344 21.254 9.24001 21.2231 9.24001C19.8756 9.24001 18.7842 10.3314 18.7842 11.6789C18.7842 13.0264 19.8756 14.1178 21.2231 14.1178C21.2523 14.1178 21.2815 14.1144 21.3125 14.1127V9.24516Z"
      fill="#94D1E0"
    />
    <defs>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint0_linear_262_44914"
        x1="4.9525"
        x2="4.9525"
        y1="9.24045"
        y2="15.3194"
      >
        <stop
          offset="0.1531"
          stopColor="#1E88E5"
        />
        <stop
          offset="1"
          stopColor="#1565C0"
        />
      </linearGradient>
    </defs>
  </svg>
);

export default EmojiU1faaa1Icon;
